<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <path
              fill="#DEEDFF"
              fill-rule="nonzero"
              d="M7 1h2v1.713c0 .224.149.42.364.481.8.226 1.526.647 2.117 1.222l.074.059c.156.102.359.11.525.015l1.481-.856 1 1.732-1.483.857c-.193.112-.29.338-.235.555.104.413.157.818.157 1.222 0 .401-.053.808-.156 1.226l-.013.093c-.01.185.084.364.249.459l1.483.856-1 1.732-1.482-.855c-.193-.112-.438-.082-.598.074-.593.575-1.32.995-2.118 1.222l-.078.029c-.172.081-.286.256-.286.452V15h-2v-1.713c0-.224-.149-.42-.364-.481-.8-.226-1.526-.647-2.117-1.222l-.074-.059c-.156-.102-.359-.11-.525-.015l-1.483.855-1-1.732 1.484-.856c.193-.112.29-.338.235-.555C3.053 8.81 3 8.403 3 8c0-.404.053-.809.157-1.222l.013-.082c.016-.19-.079-.375-.248-.473l-1.484-.857 1-1.732 1.482.856c.194.112.438.081.598-.074.593-.575 1.32-.996 2.119-1.223l.077-.029c.172-.082.286-.256.286-.452V1z"
              transform="translate(-24 -316) translate(0 300) translate(24 16)"
            />
            <path
              :fill="color"
              d="M9.5 0c.276 0 .5.224.5.5v1.849l.2.073c.554.218 1.07.516 1.534.885l.161.135 1.6-.924c.213-.123.478-.072.631.11l.052.073 1.5 2.598c.138.24.056.545-.183.683l-1.602.924.039.216c.03.195.05.39.06.585L14 8c0 .291-.023.582-.067.875l-.039.218 1.603.926c.213.123.3.378.221.601l-.038.082-1.5 2.598c-.138.24-.444.321-.683.183l-1.602-.925-.162.136c-.463.368-.979.667-1.531.884l-.201.073V15.5c0 .245-.177.45-.41.492L9.5 16h-3c-.276 0-.5-.224-.5-.5v-1.85l-.2-.072c-.554-.218-1.07-.516-1.534-.885l-.162-.135-1.6.924c-.213.123-.478.072-.631-.11l-.052-.073-1.5-2.598c-.138-.24-.056-.545.183-.683l1.601-.925-.038-.215c-.03-.195-.05-.39-.06-.585L2 8c0-.293.023-.585.068-.878l.038-.216-1.601-.924c-.213-.123-.3-.378-.221-.601l.038-.082 1.5-2.598c.138-.24.444-.321.683-.183l1.599.924.163-.135c.463-.369.98-.667 1.532-.885L6 2.348V.5c0-.245.177-.45.41-.492L6.5 0zM9 1H7v1.712c0 .196-.114.37-.286.452l-.077.029c-.8.227-1.526.648-2.119 1.223-.16.155-.404.186-.598.074l-1.482-.856-1 1.732 1.484.857c.17.098.264.283.248.473l-.013.082C3.053 7.19 3 7.596 3 8c0 .403.053.81.157 1.222.054.217-.042.443-.235.555l-1.484.856 1 1.732 1.483-.855c.166-.096.37-.087.525.015l.074.06c.591.574 1.317.995 2.117 1.22.215.062.364.258.364.482V15h2v-1.712c0-.196.114-.37.286-.452l.078-.029c.799-.227 1.525-.647 2.118-1.222.16-.156.405-.186.598-.074l1.482.855 1-1.732-1.483-.856c-.165-.095-.26-.274-.25-.46l.014-.092C12.947 8.808 13 8.4 13 8c0-.404-.053-.809-.157-1.222-.054-.217.042-.443.235-.555l1.483-.857-1-1.732-1.48.856c-.167.096-.37.087-.526-.015l-.074-.06c-.591-.574-1.317-.995-2.117-1.22C9.15 3.132 9 2.936 9 2.712V1zM8 5c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 1c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
              transform="translate(-24 -316) translate(0 300) translate(24 16)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'CogIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2')
  }
};
</script>

<style lang="scss"></style>
